import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Create React root and render the main App
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Optional: Measure performance (only if needed)
reportWebVitals();